import { useState } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch, faEye, faXmark } from '@fortawesome/free-solid-svg-icons'
import { toast } from 'react-hot-toast';
import { formatCurrency } from '../utils/currencyUtils';
import Modal from 'react-modal';

function OpenFutures({index, tradeasset, trade}) {
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const CancelFuture = (tradeid) =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/futures.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ cancelFuture : true, tradeid: tradeid })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  }
  return (
     <>
    <tr key={index}>
        <td>{index + 1}</td>
        <td className="d-lg-table-cell d-none">#{trade.order_id}</td>
        <td className="d-md-table-cell d-none">{trade.type}</td>
        <td className="d-md-table-cell d-none"><div className={`myBtn d-inline-block px-2 py-1 ${trade.side == "Long"?'bg-success':'bg-danger'}`} style={{fontSize:'12px'}}>{trade.side}</div></td>
        <td className="d-md-table-cell d-none">{trade.future_type}</td>
        <td className="d-md-table-cell d-none"><span className="ms-2 px-2 py-1 rounded-pill text-prime" style={{backgroundColor: '#ff6b3520',fontSize:'12px'}}>{trade.leverage}X</span></td>
        <td className="text-nowrap">
          <img src={tradeasset.logo} alt={tradeasset.symbol} style={{width: '30px'}}/>
          <span className="fw-bold ms-2">{tradeasset.symbol}/USDT</span> 
        </td>
        <td className="d-lg-table-cell d-none">{formatCurrency(trade.price)}</td>
        <td>{formatCurrency(Number(trade.amount) * Number(trade.leverage))}</td>
        <td className="d-lg-table-cell d-none">{((Number(trade.amount) * Number(trade.leverage)) / Number(trade.price)).toFixed(4)} {tradeasset.symbol}</td>
        <td className="d-lg-table-cell d-none">{trade.tp && trade.sl ? `${formatCurrency(trade.tp)} / ${formatCurrency(trade.sl)}` : '--'}</td>
        <td className="text-nowrap d-lg-table-cell d-none">{trade.order_time}</td>
        <td className="d-lg-table-cell d-none">
        <div className="myBtn bg-danger fw-semibold d-inline-block px-2 py-1" style={{fontSize:'12px', cursor:'pointer'}} onClick={()=> CancelFuture(trade.order_id)}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Cancel'}</div>
        </td>
        <td className="d-lg-none d-table-cell"><div className="mycard px-2 py-1 d-inline-block" onClick={() => setIsOpen(true)}><FontAwesomeIcon icon={faEye} style={{fontSize: '12px'}} /></div></td>
    </tr>
    <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        shouldCloseOnOverlayClick={true} 
        closeTimeoutMS={100}
        className="shortmode1"
    >
        <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-prime" style={{fontSize: '12px'}}>#{trade.order_id}</p>
            <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
        </div>
        <div><img src={tradeasset.logo} alt="Logo" style={{width: '20px'}} /> <span className='fw-bold text-nowrap'>{((Number(trade.amount) * Number(trade.leverage)) / Number(trade.price)).toFixed(4)} {tradeasset.symbol}</span></div>
        <hr/>
        <div className="d-flex align-items-center justify-content-between mb-2">
            <p className="mb-0 fw-bold">Type:</p>
            <p className="mb-0">{trade.type}</p>
        </div>
        <div className="d-flex align-items-center justify-content-between mb-2">
            <p className="mb-0 fw-bold">Direction:</p>
            <div className={`myBtn d-inline-block px-2 py-1 ${trade.side == "Long"?'bg-success':'bg-danger'}`} style={{fontSize:'12px'}}>{trade.side}</div>
        </div>
        <div className="d-flex align-items-center justify-content-between mb-2">
            <p className="mb-0 fw-bold">Pattern:</p>
            <p className="mb-0">{trade.future_type}</p>
        </div>
        <div className="d-flex align-items-center justify-content-between mb-2">
            <p className="mb-0 fw-bold">Leverage:</p>
            <p className="mb-0"><span className="ms-2 px-2 py-1 rounded-pill text-prime" style={{backgroundColor: '#ff6b3520',fontSize:'12px'}}>{trade.leverage}X</span></p>
        </div>
        <div className="d-flex align-items-center justify-content-between mb-2">
            <p className="mb-0 fw-bold">Entry Price:</p>
            <p className="mb-0">{formatCurrency(trade.price)}</p>
        </div>
        <div className="d-flex align-items-center justify-content-between mb-2">
            <p className="mb-0 fw-bold">TP/SL:</p>
            <p className="mb-0">{trade.tp && trade.sl ? `${formatCurrency(trade.tp)} / ${formatCurrency(trade.sl)}` : '--'}</p>
        </div>
        <div className="d-flex align-items-center justify-content-between mb-3">
            <p className="mb-0 fw-bold">Time Created:</p>
            <p className="mb-0">{trade.order_time}</p>
        </div>
        <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold"></p>
            <div className="myBtn bg-danger fw-semibold d-inline-block px-3 py-2" style={{fontSize:'12px', cursor:'pointer'}} onClick={()=> CancelFuture(trade.order_id)}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Cancel'}</div>
        </div>
    </Modal>
    </>  
  )
}

export default OpenFutures